import React, { useEffect, useState } from 'react';
import { Badge, Button, Icon, message, Modal, Steps, Switch, Table, Tag, Tooltip, Tabs } from "antd";
import ProgressBar from "./ProgressBar";
import BatteryIndicator from "../../components/BatteryIndicator";
import Widget from "../../components/Widget";
import moment from "moment";
import { DatePicker } from 'antd';
import TimeRangeSlider from "./TimeRangeSlider";
import RangeDataChart from './RangeDataChartV2';
import { calculateFuelDataFromAnalogVoltage, geojsonIndia } from '../../util/methods';
import IdleTimeModal from './IdleTimeGroupModel'
import IgnitionTimeModal from './IgnitionTimeGroupModel'
import GreenDrivingEventsModal from './GreenDrivingEventsModal'
import { Map, TileLayer, GeoJSON, Marker, Tooltip as LeafletTooltip } from 'react-leaflet'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import GeoJSONLabels from '../../components/GeoJSONLabels/GeoJSONLabels'
import ProcessedDataSummary, { buildProcessedDataSummary } from './ProcessedDataSummary'
import { getLeafletTileConfig } from '../../util/mapTiles'

const { Step } = Steps;

const greenDrivingIconUrls = {
  1: require('assets/images/icon/acceleration.png'),
  2: require('assets/images/icon/brake.png'),
  3: require('assets/images/icon/turning.png')
}

const DEVICE_DETAILS_MODAL_Z_INDEX = 1100

function parseLatLong(latLong) {
  if (!latLong || typeof latLong !== 'string') return null
  const parts = latLong.split(',').map(s => parseFloat(s.trim()))
  if (parts.length !== 2 || isNaN(parts[0]) || isNaN(parts[1])) return null
  return [parts[0], parts[1]]
}


function DeviceInfoData({
  deviceData = {},
  deviceFuelData = {},
  deviceFuelLoading = false,
  handleFuelRefreshBtn,
  assetData,
  isSSEActive = false,
  handleSSESwitchChange,
  handleFleetHistory,
  removePolylines,
  loading = false,
  setMapSpeed,
  rangeData = [],
  fetchLastManualAssetMeterReading,
  lastManualReading,
  towingData,
  liveTowingData = null,
  bleAssetsMap = {},
  urlFrom = null,
  urlTo = null,
  urlTowing = false,
}) {
  const tileLayerConfig = getLeafletTileConfig()
  const [isDarkMode, setIsDarkMode] = useState(
    typeof document !== 'undefined' && document.body && document.body.classList.contains('dark-theme')
  )
  const [isConnected, setIsConnected] = useState(false)
  const [activeTab, setActiveTab] = useState(urlFrom && urlTo ? '2' : '1')
  const [dateRange, setDateRange] = useState([])
  // const [fleetDate, setFleetDate] = useState(null)
  // const [fleetTimeRange, setFleetTimeRange] = useState([0, 0])

  const [fromFleetDate, setFromFleetDate] = useState(urlFrom ? moment(Number(urlFrom)) : null)
  const [fromFleetTimeRange, setFromFleetTimeRange] = useState(urlFrom ? [0, moment(Number(urlFrom)).format('HH:mm:ss')] : [0, 0])
  const [fromTotalTimerange, setFromTotalTimerange] = useState(0)
  const [toFleetDate, setToFleetDate] = useState(urlTo ? moment(Number(urlTo)) : null)
  const [toFleetTimeRange, setToFleetTimeRange] = useState(urlTo ? [0, moment(Number(urlTo)).format('HH:mm:ss')] : [0, 0])
  const [toTotalTimerange, setToTotalTimerange] = useState(0)
  const [queriedFromTs, setQueriedFromTs] = useState(urlFrom ? Number(urlFrom) : null)
  const [queriedToTs, setQueriedToTs] = useState(urlTo ? Number(urlTo) : null)

  const [isActive, setIsActive] = useState(false)
  const [isEyePressed, setIsEyePressed] = useState(false);
  const [deviceProcessedData, setDeviceProcessedData] = useState(null)
  const [currentSpeed, setCurrentSpeed] = useState(1)
  // const [pressIntervalId, setPressIntervalId] = useState(null);
  const [rangeMainData, setRangeMainData] = useState(null)
  const [totalTimerange, setTotalTimerange] = useState(0)
  const [totalFuelAndDistanceConsumed, setTotalFuelAndDistanceConsumed] = useState(null)
  const [isIos, setIsIos] = useState(false)
  const [hasFuelSensorAttached, setHasFuelSensorAttached] = useState(false)
  const [fuelSensorCalibrationList, setFuelSensorCalibrationList] = useState(null)

  const [isChartModalVisible, setIsChartModalVisible] = useState(false)
  const [showTowing, setShowTowing] = useState(urlTowing)
  const [bleRecordsModalVisible, setBleRecordsModalVisible] = useState(false)
  const [showBleRecordsSynthetic, setShowBleRecordsSynthetic] = useState(false)
  const [isIdleTimeModalVisible, setIsIdleTimeModalVisible] = useState(false)
  const [isIdleTimeModalDINVisible, setIsIdleTimeModalDINVisible] = useState(false)
  const [isIgnitionTimeModalVisible, setIsIgnitionTimeModalVisible] = useState(false)
  const [isIgnitionTimeModalDINVisible, setIsIgnitionTimeModalDINVisible] = useState(false)
  const [greenDrivingLogModalType, setGreenDrivingLogModalType] = useState(null)
  const [overspeedModalOpen, setOverspeedModalOpen] = useState(false)
  const [greenDrivingMapView, setGreenDrivingMapView] = useState(false)
  const [overspeedMapView, setOverspeedMapView] = useState(false)

  useEffect(() => {
    if (typeof document === 'undefined' || !document.body) return undefined

    const updateThemeState = () => {
      setIsDarkMode(document.body.classList.contains('dark-theme'))
    }

    updateThemeState()
    const observer = new MutationObserver(updateThemeState)
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })

    return () => observer.disconnect()
  }, [])

  // console.log('data_gaps', rangeData && rangeData.processedData && rangeData.processedData.data_gaps)
  const showChartModal = () => {
    setIsChartModalVisible(true);
  };

  const handleChartModalCancel = () => {
    setIsChartModalVisible(false);
  };

  useEffect(() => {
    const isIOS = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    };
    // console.log(isIOS())
    setIsIos(isIOS())
  }, []);

  // Computes the from/to timestamps from whatever period is currently selected in the date pickers,
  // independent of whether the "Show" query has actually been run yet.
  const computeSelectedFleetHistoryRange = () => {
    if (fromFleetDate && toFleetDate && fromFleetTimeRange.length === 2 && toFleetTimeRange.length === 2) {
      const fromDt = fromFleetDate.format('YYYY-MM-DD')
      const toDt = toFleetDate.format('YYYY-MM-DD')
      const fromTimestamp = new Date(`${fromDt} ${fromFleetTimeRange[1]}`).valueOf()
      const toTimestamp = new Date(`${toDt} ${toFleetTimeRange[1]}`).valueOf()
      return { fromTimestamp, toTimestamp }
    }
    return null
  }

  const handleFleetHistoryBtn = () => {
    // console.log(fleetDate)
    // console.log(fleetTimeRange)
    // console.log(new Date(dt + ' ' + fleetTimeRange[0]).valueOf())
    // console.log(new Date(dt + ' ' + fleetTimeRange[1]).valueOf())

    // console.log(fromFleetDate, fromFleetTimeRange)
    // console.log(toFleetDate, toFleetTimeRange)
    // console.log(fromTotalTimerange, toTotalTimerange)

    setRangeMainData({});
    setTotalFuelAndDistanceConsumed(null);
    // if (fleetDate && fleetTimeRange && fleetTimeRange.length === 2) {
    // const dt = fleetDate.format('YYYY-MM-DD')
    // console.log([new Date(dt + ' ' + fleetTimeRange[0]).valueOf(), new Date(dt + ' ' + fleetTimeRange[1]).valueOf()])
    // handleFleetHistory([new Date(dt + ' ' + fleetTimeRange[0]).valueOf(), new Date(dt + ' ' + fleetTimeRange[1]).valueOf()])
    const selectedRange = computeSelectedFleetHistoryRange()
    if (selectedRange) {
      const { fromTimestamp, toTimestamp } = selectedRange
      const totalTimeRangeInMinutes = Math.round((toTimestamp - fromTimestamp) / (1000 * 60))
      setTotalTimerange(totalTimeRangeInMinutes)
      // Calculate the difference in days between fromTimestamp and toTimestamp
      const daysDifference = Math.abs(moment(toTimestamp).diff(moment(fromTimestamp), 'days'));

      if (daysDifference > 2) {
        // Use antd's message component for the alert
        message.error('Date range cannot exceed 2 days. Please select a shorter range.');
      } else if (totalTimeRangeInMinutes <= 0) {
        // Use antd's message component for the alert
        message.error('Invalid date/time range. Please ensure the "From" date/time is earlier than the "To" date/time.');
      } else {
        setQueriedFromTs(fromTimestamp);
        setQueriedToTs(toTimestamp);
        handleFleetHistory([fromTimestamp, toTimestamp], showTowing);
      }
    }
    // }
  }

  const handleShareFleetHistoryUrl = () => {
    const selectedRange = computeSelectedFleetHistoryRange()
    const fromTs = selectedRange ? selectedRange.fromTimestamp : queriedFromTs
    const toTs = selectedRange ? selectedRange.toTimestamp : queriedToTs
    if (!fromTs || !toTs) {
      message.warning('Select a From and To period first before sharing.');
      return;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('from', fromTs);
    url.searchParams.set('to', toTs);
    url.searchParams.set('towing', showTowing ? 'true' : 'false');
    const shareUrl = url.toString();

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareUrl)
        .then(() => message.success('URL copied to clipboard!'))
        .catch(() => message.error('Failed to copy URL'));
    } else {
      const input = document.createElement('input');
      input.value = shareUrl;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      message.success('URL copied to clipboard!');
    }
  }

  // useEffect(() => {
  //   console.log(deviceFuelData)
  // }, [deviceFuelData]);


  const processAndSetDeviceData = (deviceData, lastManualReading = 0) => {
    if (deviceData) {
      // console.log(deviceData, lastManualReading);
      const {
        speed_gnss,
        speed_oem,
        diag_trouble_code,
        lat_long,
        bat_vol,
        ignition,
        dig_ign,
        movement,
        eye_bea_mov_1,
        engine_temp,
        fuel_level,
        fuel_level_analog,
        engine_rpm,
        odometer_kms,
        meter_diff_with_previous_record,
        timestamp,
        ignition_on_counter,
        gsm_operator,
        incoming_time
      } = deviceData || {};

      const mv = (movement && Number(movement) && !!Number(movement)) || (eye_bea_mov_1 && Number(eye_bea_mov_1) && Number(eye_bea_mov_1) === 1)
      const ign = (dig_ign && Number(dig_ign) && !!Number(dig_ign)) || (ignition && Number(ignition) && !!Number(ignition))

      // console.log(mv, ign);

      // function secondsToHms(seconds) {
      //   const duration = moment.duration(seconds, 'seconds');
      //   const hh = String(Math.floor(duration.asHours())).padStart(2, '0');
      //   const mm = String(duration.minutes()).padStart(2, '0');
      //   const ss = String(duration.seconds()).padStart(2, '0');

      //   return `${hh}:${mm}:${ss}`;
      // }

      // Function to convert seconds to hours (decimal)
      function secondsToHours(seconds) {
        return (seconds / 3600).toFixed(2);
      }

      const timeDifference = moment(new Date().getTime()).diff(moment(incoming_time), 'seconds');
      // console.log('timeDifference =>', Math.abs(timeDifference))
      const isDeviceOffline = Math.abs(timeDifference) >= 300;
      // console.log('isDeviceOffline =>', isDeviceOffline)

      let isSynching = false;
      const timestampDifference = moment(new Date().getTime()).diff(moment(timestamp), 'seconds');
      // console.log('timestampDifference =>', timestampDifference)
      if (!isDeviceOffline && timestampDifference > 500) {
        // const tts = moment(new Date().getTime()).diff(moment(incoming_time), 'seconds');
        isSynching = true;
      }
      // console.log('isSynching =>', isSynching)
      setIsConnected(!isDeviceOffline || isSynching)
      let isKmFromManaul = false;
      let isHoursFromManaul = false;
      let meter = odometer_kms && Number(odometer_kms) && Number(odometer_kms) / 1000 || 0
      let ignition_on_counter_hours = ignition_on_counter && Number(ignition_on_counter) && Number(ignition_on_counter) / 3600 || 0
      // console.log(assetData, lastManualReading)
      if (lastManualReading && assetData && assetData._id) {
        const { assetModel, _id } = assetData;
        const { timestamp } = deviceData;

        const kms = assetModel && assetModel.meters && assetModel.meters.length && assetModel.meters.filter(m => m.name === 'KMS')
        if (kms && kms[0] && kms[0]._id) {
          const key = `${_id}-${kms[0]._id}-${timestamp}`
          const lastManualReadingKm = lastManualReading[key]
          if (lastManualReadingKm) {
            let lastIotReading = lastManualReadingKm && lastManualReadingKm.lastIotReading && Number(lastManualReadingKm.lastIotReading) && Number(lastManualReadingKm.lastIotReading) / 1000 || 0
            meter = lastManualReadingKm.reading + meter - lastIotReading
            isKmFromManaul = true
          }
        }

        const hours = assetModel && assetModel.meters && assetModel.meters.length && assetModel.meters.filter(m => m.name === 'HOURS')
        if (hours && hours[0] && hours[0]._id) {
          const keyHrs = `${_id}-${hours[0]._id}-${timestamp}`
          const lastManualReadingHours = lastManualReading[keyHrs]
          if (lastManualReadingHours) {
            let lastIotReadingHrs = lastManualReadingHours && lastManualReadingHours.lastIotReading && Number(lastManualReadingHours.lastIotReading) && Number(lastManualReadingHours.lastIotReading) / 1000 || 0
            ignition_on_counter_hours = lastManualReadingHours.reading + ignition_on_counter_hours - lastIotReadingHrs
            isHoursFromManaul = true
          }
        }
      }

      // console.log('Ignition on counter - ', ignition_on_counter)

      setDeviceProcessedData({
        lat_long,
        timestamp,
        speed: speed_oem ? speed_oem : speed_gnss ? speed_gnss : '-',
        speed_title: speed_oem ? 'OEM Speed' : speed_gnss ? 'GPS Speed' : 'Speed',
        bat_vol: bat_vol && Number(bat_vol) && `${(Number(bat_vol) / 1000).toFixed(2)} Voltage` || '-',
        status: isSynching ? 'syncing' : isDeviceOffline ? 'offline' : (ign && mv) ? 'moving' : (ign && !mv) ? 'waiting' : 'stop',
        fuel_level: fuel_level && Number(fuel_level) || 0,
        fuel_level_analog: fuel_level_analog && Number(fuel_level_analog) || 0,
        engine_temp: engine_temp && Number(engine_temp) && `${(Number(engine_temp)).toFixed(1)} °C` || '-',
        engine_rpm: engine_rpm && Number(engine_rpm) && `${(Number(engine_rpm)).toFixed(0)} RPM` || '-',
        meter: `${meter.toFixed(2)} Kms ${isKmFromManaul ? '(*)' : ''}`,
        diag_trouble_code: diag_trouble_code && Number(diag_trouble_code) || 0,
        ignition_on_counter: ignition_on_counter_hours && `${ignition_on_counter_hours.toFixed(2)} Hrs ${isHoursFromManaul ? '(*)' : ''}` || 0,
        gsm_operator,
        // Packet came from the daily-data backup because the live table had no record
        isBackupData: deviceData._source === 'daily_backup',
        // fuel: fuel && Number(fuel) && `${(Number(fuel) / 10).toFixed(2)} ltr(s)` || '-',
        // fuel_time,
        // fuelIsLive
      });
    }
  }

  useEffect(() => {
    // console.log('deviceData - ', deviceData)
    processAndSetDeviceData(deviceData)
  }, [deviceData]);

  useEffect(() => {
    if (assetData && deviceData) {
      const { assetModel, _id } = assetData;
      const { timestamp } = deviceData;

      const kms = assetModel && assetModel.meters && assetModel.meters.length && assetModel.meters.filter(m => m.name === 'KMS')
      const hours = assetModel && assetModel.meters && assetModel.meters.length && assetModel.meters.filter(m => m.name === 'HOURS')
      // console.log(assetData, deviceData, kms);

      if (kms && kms[0] && kms[0]._id) {
        // console.log('fetching --manual reading for kms');
        fetchLastManualAssetMeterReading(_id, kms[0]._id, timestamp);
      }

      if (hours && hours[0] && hours[0]._id) {
        // console.log('fetching --manual reading for hours');
        fetchLastManualAssetMeterReading(_id, hours[0]._id, timestamp);
      }

      checkSensorAttached(assetData, deviceData.device_id)
    }
  }, [deviceData, assetData])

  const checkSensorAttached = (asset, deviceId) => {
    // console.log('asset - ', asset)
    // console.log('deviceId - ', deviceId)
    const device = (asset.dependents || []).filter(d => d && d.tagDeviceId && (d.tagDeviceId === deviceId || d.tagDeviceId.split("_")[0] === deviceId))
    // console.log('device - ', device)
    const dependents = device && device[0] && device[0].dependents || [];
    dependents.forEach(dependent => {
      if (dependent && dependent.assetModel && dependent.assetModel.isFuelSensorDevice) {
        setHasFuelSensorAttached(true)
        setFuelSensorCalibrationList(dependent.fuelSensorCalibrationList && dependent.fuelSensorCalibrationList.list || null)
        // break the loop
        return;
      }
    })
    // if (dependents && dependents[0] && dependents[0].assetModel && dependents[0].assetModel.isFuelSensorDevice) {
    //   setHasFuelSensorAttached(true)
    //   setFuelSensorCalibrationList(dependents[0].fuelSensorCalibrationList && dependents[0].fuelSensorCalibrationList.list || null)
    // }
  }


  useEffect(() => {
    // console.log('lastManualReading - ', lastManualReading)
    if (lastManualReading && deviceData)
      processAndSetDeviceData(deviceData, lastManualReading)
  }, [lastManualReading, deviceData])

  useEffect(() => {
    const summary = buildProcessedDataSummary(rangeData, hasFuelSensorAttached, fuelSensorCalibrationList);
    setRangeMainData(summary && summary.rangeMainData ? summary.rangeMainData : null);
    setTotalFuelAndDistanceConsumed(summary && summary.totalFuelAndDistanceConsumed ? summary.totalFuelAndDistanceConsumed : null);
  }, [rangeData, hasFuelSensorAttached, fuelSensorCalibrationList]);


  // useEffect(() => {

  //   if (rangeData && rangeData.data && rangeData.data.length) {
  //     setTotalFuelAndDistanceConsumed(calculateFuelAndDistanceConsumed(rangeData.data));
  //   }
  // }, [rangeData]);


  // const onChangeDate = (date) => {
  //   if (date) {
  //     setFleetDate(date);
  //   }
  // }
  const onChangeToDate = (date) => {
    if (date) {
      setToFleetDate(date);
    }
  }
  const onChangeFromDate = (date) => {
    if (date) {
      setFromFleetDate(date);
      if (!toFleetDate || toFleetDate.isBefore(date)) {
        setToFleetDate(date)
      }
    }
  }

  useEffect(() => {
    setIsActive(isSSEActive);
  }, [isSSEActive]);

  // const onEyeClickToggleHandle = () => {
  //   setIsEyePressed(!isEyePressed);
  // };

  useEffect(() => {
    setDeviceProcessedData({
      lat_long: [0, 0],
      timestamp: null,
      speed: '-',
      speed_title: 'Speed',
      bat_vol: '-',
      status: 'offline',
      fuel_level: '',
      fuel_level_analog: '',
      engine_temp: '-',
      engine_rpm: '-',
      meter: '-',
      diag_trouble_code: 0,
      ignition_on_counter: 0,
      gsm_operator: '-',
      // fuel: null,
      // fuel_time: null,
      // fuelIsLive: true,
    });
  }, []);

  const onSpeedChange = (current) => {
    setCurrentSpeed(current)
  }

  useEffect(() => {
    setMapSpeed(currentSpeed)
  }, [currentSpeed]);

  const displayTiming = () => {
    if (fromFleetDate && toFleetDate && fromFleetTimeRange.length === 2 && toFleetTimeRange.length === 2) {
      const fromDt = fromFleetDate.format('YYYY-MM-DD')
      const toDt = toFleetDate.format('YYYY-MM-DD')
      const fromTimestamp = new Date(`${fromDt} ${fromFleetTimeRange[1]}`).valueOf()
      const toTimestamp = new Date(`${toDt} ${toFleetTimeRange[1]}`).valueOf()

      const formattedFromDate = moment(fromTimestamp).format('Do MMM')
      const formattedToDate = moment(toTimestamp).format('Do MMM')
      const formattedFromTime = moment(fromTimestamp).format('HH:mm')
      const formattedToTime = moment(toTimestamp).format('HH:mm')
      const timeRangeString = `Trip Period: ${formattedFromDate} ${formattedFromTime} - ${formattedToDate} ${formattedToTime}`
      return timeRangeString
    }
  }

  const availableTiming = () => {
    const { data } = rangeData || {};
    if (data && data.length && fromFleetDate && toFleetDate) {
      const {
        timestamp: firstTimestamp,
      } = data[0] || {};
      const {
        timestamp: lastTimestamp,
      } = data[rangeData.data.length - 1] || {};

      const fromDt = fromFleetDate.format('YYYY-MM-DD')
      const toDt = toFleetDate.format('YYYY-MM-DD')
      const fromTimestamp = new Date(`${fromDt} ${fromFleetTimeRange[1]}`).valueOf()
      const toTimestamp = new Date(`${toDt} ${toFleetTimeRange[1]}`).valueOf()

      const formattedFromDate = moment(firstTimestamp).format('Do MMM')
      const formattedToDate = moment(lastTimestamp).format('Do MMM')
      const formattedFromTime = moment(firstTimestamp).format('HH:mm')
      const formattedToTime = moment(lastTimestamp).format('HH:mm')
      const timeDiff = (lastTimestamp - firstTimestamp) - (toTimestamp - fromTimestamp)
      // console.log('timeDiff - ', timeDiff)
      const hasGap = Math.abs(timeDiff) > 1000
      const timeRangeString = <span style={{ color: hasGap ? (isDarkMode ? '#ff7b72' : 'red') : (isDarkMode ? '#7ee2a8' : 'green') }}>Data available: {formattedFromDate} {formattedFromTime} - {formattedToDate} {formattedToTime}</span>
      return timeRangeString
    }
  }


  let fuel = '-';
  let fuelIsLive = true;
  let fuel_time = deviceProcessedData && deviceProcessedData.timestamp;
  // console.log('deviceProcessedData - ', deviceProcessedData)
  // console.log('hasFuelSensorAttached - ', hasFuelSensorAttached)
  // console.log('fuelSensorCalibrationList - ', fuelSensorCalibrationList)
  if (deviceProcessedData && deviceProcessedData.fuel_level_analog && hasFuelSensorAttached && fuelSensorCalibrationList) {
    // console.log('liveeee..')
    // console.log('deviceProcessedData.fuel_level_analog - ', deviceProcessedData.fuel_level_analog)
    fuel = calculateFuelDataFromAnalogVoltage(Number(deviceProcessedData.fuel_level_analog), fuelSensorCalibrationList).toFixed(2) + ' ltr (~)';
  } else if (deviceProcessedData && deviceProcessedData.fuel_level) {
    // console.log('liveeee..')
    fuel = (Number(deviceProcessedData.fuel_level) / 10).toFixed(2) + ' ltr(s)';
  } else if (deviceFuelData && deviceFuelData.fuel_level_analog) {
    // console.log('Apii')
    fuel = calculateFuelDataFromAnalogVoltage(Number(deviceFuelData.fuel_level_analog), fuelSensorCalibrationList).toFixed(2) + ' ltr (~)';
    fuelIsLive = false;
    fuel_time = deviceFuelData && deviceFuelData.timestamp;
  } else if (deviceFuelData && deviceFuelData.fuel_level) {
    // console.log('Apii')
    fuel = (Number(deviceFuelData.fuel_level) / 10).toFixed(2) + ' ltr(s)';
    fuelIsLive = false;
    fuel_time = deviceFuelData && deviceFuelData.timestamp;
  }

  return (
    <>
      <div className="device-info-panel">
        <Widget>
          <Tabs activeKey={activeTab} onChange={setActiveTab}>
            <Tabs.TabPane tab="Device Status" key="1"
              style={{ minHeight: '87vh', maxHeight: '87vh', overflowY: 'auto', paddingRight: '5px' }}>

              <div style={{ marginBottom: 10, marginTop: 10 }}>
                <div style={{ float: 'right' }}>
                  <i className={`icon icon-culture-calendar gx-fs-xxl ${isConnected ? 'gx-text-green' : 'gx-text-grey'}`} />
                  {/*<Badge color={isConnected ? "#49d909" : "#8d918d"}*/}
                  {/*       style={{width: '18px', borderRadius: '25px'}}/>*/}
                </div>
                <span><Switch defaultChecked={isActive} checked={isActive}
                  onChange={handleSSESwitchChange} /> {isActive ? 'Stop' : 'Start'} Live Feed</span>
                <ProgressBar timeValue={10100} isActive={isActive} />
              </div>

              {deviceProcessedData && <>
                <div key={'time'}
                  className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list"
                  style={{ marginBottom: 10, marginTop: 10 }}>
                  <div className="gx-mr-3">
                    <img alt="..." src={require(`assets/images/icon/timestamp.png`)}
                      className="" />
                  </div>
                  <div className="gx-media-body">
                    <span className="gx-mb-0 gx-text-grey gx-fs-sm">Time</span>
                    <p
                      className="gx-mb-0">{deviceProcessedData.timestamp && moment(deviceProcessedData.timestamp).toLocaleString()}
                      {deviceProcessedData.isBackupData &&
                        <Tooltip title={'No live record found. Showing the last packet saved in daily data.'}>
                          <Tag color={'orange'} style={{ marginLeft: 8 }}>Last known</Tag>
                        </Tooltip>}
                    </p>
                  </div>
                </div>
                <hr />
                <div key={'status'}
                  className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list"
                  style={{ marginBottom: 10 }}>
                  <div className="gx-mr-3">
                    <img alt="..." src={require(`assets/images/icon/${deviceProcessedData.status}.png`)}
                      className="" />
                  </div>
                  <div className="gx-media-body">
                    <span className="gx-mb-0 gx-text-grey gx-fs-sm">Status</span>
                    <p
                      className="gx-mb-0">{deviceProcessedData.status && (deviceProcessedData.status.charAt(0).toUpperCase() + deviceProcessedData.status.slice(1))}</p>
                  </div>
                </div>
                <hr />
                <div key={'battery'}
                  className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list"
                  style={{ marginBottom: 10 }}>
                  <div className="gx-mr-3">
                    <img alt="..." src={require('assets/images/icon/battery.png')} className="" />
                  </div>
                  <div className="gx-media-body">
                    <span className="gx-mb-0 gx-text-grey gx-fs-sm">Battery Voltage</span>
                    <p className="gx-mb-0">{deviceProcessedData && deviceProcessedData.bat_vol || '-'}</p>
                  </div>
                </div>
                <hr />
                <div key={'fuel'}
                  className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list"
                  style={{ marginBottom: 10 }}>
                  <div className="gx-mr-3">
                    <img alt="..." src={require('assets/images/icon/fuel.png')} className="" />
                  </div>
                  <div className="gx-media-body">
                    <div className={'ant-row-flex gx-justify-content-between'}>
                      <div className={'ant-row-flex-start'}>
                        <span className="gx-mb-0 gx-text-grey gx-fs-sm">Fuel Level</span>
                        <p
                          className="gx-mb-0">{fuel}</p>
                      </div>
                      <div>
                        <Tooltip title={'Refresh'}>
                          <Button disabled={fuelIsLive} size={'small'} icon={'sync'}
                            style={{ marginBottom: '5px' }}
                            title={'Refresh'} loading={deviceFuelLoading}
                            onClick={handleFuelRefreshBtn} />
                        </Tooltip>
                        <Tooltip
                          title={fuel_time && 'As on time - ' + moment(fuel_time).toLocaleString() || ''}>
                          <Icon type="info-circle" style={{ fontSize: '15px', cursor: 'pointer', color: isDarkMode ? '#94c5ec' : undefined }} />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div key={'speed'}
                  className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list"
                  style={{ marginBottom: 10 }}>
                  <div className="gx-mr-3">
                    <img alt="..." src={require('assets/images/icon/speed.png')} className="" />
                  </div>
                  <div className="gx-media-body">
                    <div className={'ant-row-flex gx-justify-content-between'}>
                      <div className={'ant-row-flex-start'}>
                        <span
                          className="gx-mb-0 gx-text-grey gx-fs-sm gx-text-hover">Speed{assetData && assetData.speedLimit != null && assetData.speedLimit !== '' ? ` (${Number(assetData.speedLimit)}Km/hr)` : ''}</span>
                        <p
                          className="gx-mb-0">{deviceProcessedData.speed}</p>
                      </div>
                      <Tooltip title={deviceProcessedData.speed_title}>
                        <Icon type="info-circle" style={{ fontSize: '15px', cursor: 'pointer', color: isDarkMode ? '#94c5ec' : undefined }} />
                      </Tooltip>
                    </div>
                  </div>
                </div>
                <hr />
                <div key={'counter'}
                  className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list"
                  style={{ marginBottom: 10 }}>
                  <div className="gx-mr-3">
                    <img alt="..." src={require('assets/images/icon/counter.png')} className="" />
                  </div>
                  <div className="gx-media-body">
                    <span className="gx-mb-0 gx-text-grey gx-fs-sm">Meter Reading</span>
                    <p className="gx-mb-0">{deviceProcessedData && deviceProcessedData.meter || '-'}</p>
                    <p className="gx-mb-0">{deviceProcessedData && deviceProcessedData.ignition_on_counter || '-'}</p>
                  </div>
                </div>
                <hr />
                <div key={'temp'}
                  className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list"
                  style={{ marginBottom: 10 }}>
                  <div className="gx-mr-3">
                    <img alt="..." src={require('assets/images/icon/temperature.png')} className="" />
                  </div>
                  <div className="gx-media-body">
                    <span className="gx-mb-0 gx-text-grey gx-fs-sm">Engine Temperature</span>
                    <p className="gx-mb-0">{deviceProcessedData && deviceProcessedData.engine_temp || '-'}</p>
                  </div>
                </div>
                <hr />
                <div key={'rpm'}
                  className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list"
                  style={{ marginBottom: 10 }}>
                  <div className="gx-mr-3">
                    <img alt="..." src={require('assets/images/icon/rpm.png')} className="" />
                  </div>
                  <div className="gx-media-body">
                    <span className="gx-mb-0 gx-text-grey gx-fs-sm">RPM</span>
                    <p className="gx-mb-0">{deviceProcessedData && deviceProcessedData.engine_rpm || '-'}</p>
                  </div>
                </div>
                <hr />
                <div key={'lat'}
                  className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list"
                  style={{ marginBottom: 10 }}>
                  <div className="gx-mr-3">
                    <img alt="..." src={require('assets/images/icon/navigation.png')} className="" />
                  </div>
                  <div className="gx-media-body">
                    <span className="gx-mb-0 gx-text-grey gx-fs-sm">Lat/Long</span>
                    <p className="gx-mb-0">{deviceProcessedData && deviceProcessedData.lat_long || '-'}</p>
                  </div>
                </div>
                <hr />
                <div key={'network'}
                  className="gx-media gx-align-items-center gx-flex-nowrap gx-pro-contact-list"
                  style={{ marginBottom: 10 }}>
                  <div className="gx-mr-3">
                    <img alt="..." src={require('assets/images/icon/network.png')} className="" />
                  </div>
                  <div className="gx-media-body">
                    <span className="gx-mb-0 gx-text-grey gx-fs-sm">Network</span>
                    <p className="gx-mb-0">{deviceProcessedData && deviceProcessedData.gsm_operator || '-'}</p>
                  </div>
                </div>

                {/* ── Live Towing Panel ── */}
                {(() => {
                  if (!liveTowingData || !liveTowingData.activeTowing || !liveTowingData.activeTowing.length) return null
                  const deviceTs = Number(deviceProcessedData && deviceProcessedData.timestamp) || 0
                  const WINDOW_MS = 30000
                  const matched = liveTowingData.activeTowing.filter(t => Math.abs(Number(t.updatedAt) - deviceTs) <= WINDOW_MS)
                  if (!matched.length) return null
                  return (
                    <div style={{ marginTop: 12 }}>
                      <hr />
                      <div style={{
                        background: 'linear-gradient(135deg, #fff2e8 0%, #fff7f0 100%)',
                        border: '1.5px solid #fa8c16',
                        borderRadius: 8,
                        padding: '10px 12px',
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 8 }}>
                          <span style={{ fontSize: 16 }}>🚨</span>
                          <span style={{ fontWeight: 700, color: '#d46b08', fontSize: 13, letterSpacing: 0.2 }}>
                            Active Towing Detected
                          </span>
                          <span style={{
                            marginLeft: 'auto', background: '#fa8c16', color: '#fff',
                            borderRadius: 10, fontSize: 10, fontWeight: 700,
                            padding: '1px 7px',
                          }}>
                            {matched.length} beacon{matched.length !== 1 ? 's' : ''}
                          </span>
                        </div>
                        {matched.map((t, i) => (
                          <div key={t.instanceId || i} style={{
                            background: '#fff',
                            borderRadius: 6,
                            padding: '7px 10px',
                            marginBottom: i < matched.length - 1 ? 6 : 0,
                            border: '1px solid #ffe7ba',
                          }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 3 }}>
                              <span style={{ color: '#fa8c16', fontWeight: 700, fontSize: 12, fontFamily: 'monospace' }}>
                                {t.instanceId || '—'}
                              </span>
                              {t.activeDisplacementM > 0 && (
                                <span style={{ marginLeft: 'auto', color: '#d46b08', fontSize: 11, fontWeight: 600 }}>
                                  {Math.round(t.activeDisplacementM)} m displaced
                                </span>
                              )}
                            </div>
                            {t.towingSinceTs && (
                              <div style={{ fontSize: 11, color: '#8c6d00' }}>
                                Since {moment(Number(t.towingSinceTs)).format('DD/MM HH:mm:ss')}
                              </div>
                            )}
                            {t.locationAtEvent && (
                              <div style={{ fontSize: 10, color: '#999', marginTop: 2 }}>
                                📍 {t.locationAtEvent}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                })()}
              </>
              }
            </Tabs.TabPane>
            <Tabs.TabPane tab="Fleet History" key="2"
              style={{ minHeight: '87vh', maxHeight: '87vh', overflowY: 'auto', paddingRight: '5px' }}>
              {/* <p className="gx-text-grey gx-mb-0">Show fleet history</p> */}
              <div className={'-card-full'}>
                <div className="gx-mt-1 gx-pl-3 gx-pr-3">
                  <div className="gx-mb-1">
                    {/* <p className="gx-text-grey gx-mb-1">From</p> */}
                    <div className="gx-d-flex gx-align-items-center">
                      {isIos ? (
                        <input
                          placeholder="Select From Date"
                          type="date"
                          onChange={(e) => onChangeFromDate(moment(e.target.value))}
                          style={{
                            width: '100%',
                            padding: '10px',
                            boxSizing: 'border-box',
                            borderRadius: '5px',
                            border: '.5px solid #cdcdcd',
                            height: '35px'
                          }}
                        />
                      ) : (
                        <DatePicker
                          placeholder="Select From Date"
                          size={'default'}
                          format="YYYY-MM-DD"
                          onChange={onChangeFromDate}
                          value={fromFleetDate}
                          style={{ width: '100%' }}
                        />
                      )}
                    </div>
                    <TimeRangeSlider
                      setFleetTimeRange={setFromFleetTimeRange}
                      setTotalTimerange={setFromTotalTimerange}
                      selectedDate={fromFleetDate}
                      initialMinutes={urlFrom ? moment(Number(urlFrom)).hours() * 60 + moment(Number(urlFrom)).minutes() : undefined}
                    />
                  </div>

                  <div>
                    {/* <p className="gx-text-grey gx-mb-1">To</p> */}
                    <div className="gx-d-flex gx-align-items-center">
                      {isIos ? (
                        <input
                          placeholder="Select To Date"
                          type="date"
                          onChange={(e) => onChangeToDate(moment(e.target.value))}
                          style={{
                            width: '100%',
                            padding: '10px',
                            boxSizing: 'border-box',
                            borderRadius: '5px',
                            border: '.5px solid #cdcdcd',
                            height: '35px'
                          }}
                        />
                      ) : (
                        <DatePicker
                          placeholder="Select To Date"
                          size={'default'}
                          format="YYYY-MM-DD"
                          onChange={onChangeToDate}
                          value={toFleetDate}
                          disabledDate={(current) => {
                            // Can't select days before the "from" date
                            return fromFleetDate && current && current.isBefore(fromFleetDate, 'day')
                          }}
                          style={{ width: '100%' }}
                        />
                      )}
                    </div>
                    <TimeRangeSlider
                      setFleetTimeRange={setToFleetTimeRange}
                      setTotalTimerange={setToTotalTimerange}
                      selectedDate={toFleetDate}
                      initialMinutes={urlTo ? moment(Number(urlTo)).hours() * 60 + moment(Number(urlTo)).minutes() : undefined}
                    />
                  </div>
                </div>

                {/* {isIos ? (
              <input
                type="date"
                onChange={(e) => onChangeDate(moment(e.target.value))}
                style={{
                  width: '100%',
                  padding: '10px',
                  boxSizing: 'border-box',
                  borderRadius: '5px',
                  border: '.5px solid #cdcdcd',
                  height: '35px'
                }}
              />
            ) : (
              <DatePicker size={'default'} format="YYYY-MM-DD" onChange={onChangeDate}
                style={{ width: '100%' }} />
            )}
            <TimeRangeSlider setFleetTimeRange={setFleetTimeRange} setTotalTimerange={setTotalTimerange}
              selectedDate={fleetDate} /> */}

                <div style={{ marginTop: 20, textAlign: 'center', marginBottom: 20, }}>
                  {displayTiming()}
                  <p>{availableTiming()}</p>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
                  <Switch
                    size="small"
                    checked={showTowing}
                    onChange={setShowTowing}
                  />
                  <span style={{ fontSize: 12 }}>Show Towing</span>
                  <Tooltip title="Copy shareable URL for this Fleet History query">
                    <Icon
                      type="share-alt"
                      style={{ fontSize: 16, cursor: 'pointer', color: '#1890ff', marginLeft: 'auto' }}
                      onClick={handleShareFleetHistoryUrl}
                    />
                  </Tooltip>
                </div>
                <Button
                  className={'gx-btn-cyan'}
                  icon={'check-circle'}
                  loading={loading}
                  onClick={handleFleetHistoryBtn}>Show</Button>
                <Button
                  icon={'area-chart'}
                  onClick={showChartModal}
                  disabled={!rangeData || !rangeData.data || rangeData.data.length === 0}>
                  View Chart
                </Button>
                {towingData && towingData.data && towingData.data.length > 0 && (
                  <Button
                    icon="tags"
                    onClick={() => setBleRecordsModalVisible(true)}
                  >
                    BLE Records ({towingData.data.length})
                  </Button>
                )}
              </div>

              <ProcessedDataSummary
                rangeData={rangeData}
                rangeMainData={rangeMainData}
                totalFuelAndDistanceConsumed={totalFuelAndDistanceConsumed}
                hasFuelSensorAttached={hasFuelSensorAttached}
                fuelSensorCalibrationList={fuelSensorCalibrationList}
                isDarkMode={isDarkMode}
                onShowIdleTime={() => setIsIdleTimeModalVisible(true)}
                onShowIdleTimeDin={() => setIsIdleTimeModalDINVisible(true)}
                onShowIgnitionTime={() => setIsIgnitionTimeModalVisible(true)}
                onShowIgnitionTimeDin={() => setIsIgnitionTimeModalDINVisible(true)}
                onShowGreenDriving={() => setGreenDrivingLogModalType('all')}
                onShowOverspeed={() => setOverspeedModalOpen(true)}
              />


            </Tabs.TabPane>

          </Tabs>
        </Widget>
      </div>

      {isChartModalVisible &&
        <Modal
          title="Range Data Chart"
          visible={isChartModalVisible}
          onCancel={handleChartModalCancel}
          footer={null}
          zIndex={DEVICE_DETAILS_MODAL_Z_INDEX}
          width="90%"
          style={{ top: 20 }}
          wrapClassName="device-details-modal"
          bodyStyle={{ height: 'calc(90vh - 108px)' }}
        >
          {rangeData && rangeData.data && rangeData.data.length > 0 && (
            <RangeDataChart data={rangeData.data} hasFuelSensorAttached={hasFuelSensorAttached}
              data_gaps={rangeData && rangeData.processedData && rangeData.processedData.data_gaps || []}
              consumedData={rangeData && rangeData.processedData && rangeData.processedData.newConsumed || null}
              fuelSensorCalibrationList={fuelSensorCalibrationList}
              isDarkMode={isDarkMode}
              title={`Data Chart for ${assetData.assetCode || '-'} / ${assetData.altName || '-'} / ${assetData.ownerCode || '-'}`}
            />
          )}
        </Modal>
      }

      {isIdleTimeModalVisible && (

        <Modal
          title={'Idle Time Details'}
          visible={isIdleTimeModalVisible && rangeMainData && rangeMainData.pauseTimeGroup && rangeMainData.pauseTimeGroup.length > 0}
          onCancel={() => setIsIdleTimeModalVisible(false)}
          footer={null}
          zIndex={DEVICE_DETAILS_MODAL_Z_INDEX}
          width={'90%'}
          wrapClassName="device-details-modal"
          style={{ top: 10 }}
        // bodyStyle={{ height: 'calc(90vh - 108px)' }}
        >
          <IdleTimeModal
            idleTimeData={rangeMainData && rangeMainData.pauseTimeGroup || []}
            hasFuelSensorAttached={hasFuelSensorAttached}
            idleConsumptionRate={assetData && assetData.assetModel && assetData.assetModel.idealFuelConsumptionRate}
            fuelRate={assetData && assetData.assetModel && assetData.assetModel.fuelType && assetData.assetModel.fuelType.currentRate}
          />
        </Modal>
      )}

      {isIdleTimeModalDINVisible && (
        <Modal
          title={'Idle Time Details (DIN)'}
          visible={isIdleTimeModalDINVisible && rangeMainData && rangeMainData.pauseTimeGroupDIN && rangeMainData.pauseTimeGroupDIN.length > 0}
          onCancel={() => setIsIdleTimeModalDINVisible(false)}
          footer={null}
          zIndex={DEVICE_DETAILS_MODAL_Z_INDEX}
          width={'90%'}
          wrapClassName="device-details-modal"
          style={{ top: 10 }}
        // bodyStyle={{ height: 'calc(90vh - 108px)' }}
        >
          <IdleTimeModal
            idleTimeData={rangeMainData && rangeMainData.pauseTimeGroupDIN || []}
            hasFuelSensorAttached={hasFuelSensorAttached}
            idleConsumptionRate={assetData && assetData.assetModel && assetData.assetModel.idealFuelConsumptionRate}
            fuelRate={assetData && assetData.assetModel && assetData.assetModel.fuelType && assetData.assetModel.fuelType.currentRate}
          />
        </Modal>
      )}

      {isIgnitionTimeModalVisible && (
        <Modal
          title={'Ignition Time Details'}
          visible={isIgnitionTimeModalVisible && rangeMainData && rangeMainData.ignitionTimeGroup && rangeMainData.ignitionTimeGroup.length > 0}
          onCancel={() => setIsIgnitionTimeModalVisible(false)}
          footer={null}
          zIndex={DEVICE_DETAILS_MODAL_Z_INDEX}
          width={'90%'}
          wrapClassName="device-details-modal"
          style={{ top: 10 }}
        >
          <IgnitionTimeModal
            ignitionTimeData={rangeMainData && rangeMainData.ignitionTimeGroup || []}
          />
        </Modal>
      )}

      {isIgnitionTimeModalDINVisible && (
        <Modal
          title={'Ignition Time Details (DIN)'}
          visible={isIgnitionTimeModalDINVisible && rangeMainData && rangeMainData.ignitionTimeGroupDIN && rangeMainData.ignitionTimeGroupDIN.length > 0}
          onCancel={() => setIsIgnitionTimeModalDINVisible(false)}
          footer={null}
          zIndex={DEVICE_DETAILS_MODAL_Z_INDEX}
          width={'90%'}
          wrapClassName="device-details-modal"
          style={{ top: 10 }}
        >
          <IgnitionTimeModal
            ignitionTimeData={rangeMainData && rangeMainData.ignitionTimeGroupDIN || []}
          />
        </Modal>
      )}

      {greenDrivingLogModalType != null && (() => {
        const greenDriving = rangeData && rangeData.processedData && (rangeData.processedData.green_driving_summary || rangeData.processedData.green_drivng_summery)
        const eventLabels = { 1: 'Harsh Acceleration', 2: 'Harsh Braking', 3: 'Harsh Cornering' }
        const eventIcons = { 1: 'acceleration', 2: 'brake', 3: 'turning' }
        const counts = (greenDriving && greenDriving.counts) || { 1: 0, 2: 0, 3: 0 }
        const logs = (greenDriving && greenDriving.logs) || { 1: [], 2: [], 3: [] }
        if (greenDrivingLogModalType === 'all') {
          const tableColumns = [
            { title: 'Time', dataIndex: 'timestamp', key: 'ts', render: (t) => t != null ? moment(t).format('DD/MM/YYYY HH:mm:ss') : '-' },
            { title: 'Location', dataIndex: 'lat_long', key: 'loc', render: (v) => v || '-' }
          ]
          const allEventsWithPosition = []
            ;[1, 2, 3].forEach((k) => {
              (logs[k] || []).forEach((evt, i) => {
                const position = parseLatLong(evt.lat_long)
                if (position) {
                  allEventsWithPosition.push({
                    ...evt,
                    key: `gd-${k}-${i}`,
                    eventTypeKey: k,
                    position
                  })
                }
              })
            })
          const mapCenter = allEventsWithPosition.length > 0
            ? allEventsWithPosition[0].position
            : [20.5937, 78.9629]
          const totalEvents = (logs[1] || []).length + (logs[2] || []).length + (logs[3] || []).length
          return (
            <Modal
              title="Harsh Driving Events"
              visible={true}
              onCancel={() => { setGreenDrivingLogModalType(null); setGreenDrivingMapView(false) }}
              footer={null}
              zIndex={DEVICE_DETAILS_MODAL_Z_INDEX}
              width="90%"
              wrapClassName="device-details-modal"
              style={{ top: 10 }}
            >
              {greenDrivingMapView ? (
                <div style={{ height: '600px' }}>
                  <Map
                    center={mapCenter}
                    zoom={allEventsWithPosition.length > 0 ? 12 : 10}
                    maxZoom={tileLayerConfig.maxZoom || 18}
                    attributionControl={false}
                    style={{ height: '100%' }}
                  >
                    <TileLayer
                      url={tileLayerConfig.url}
                      subdomains={tileLayerConfig.subdomains}
                    />
                    <GeoJSON data={geojsonIndia} style={{ color: isDarkMode ? '#64748b' : 'grey', weight: 1 }} />
                    <GeoJSONLabels zoom={18} minZoomLevel={17} />
                    {allEventsWithPosition.map((item) => {
                      const iconUrl = greenDrivingIconUrls[item.eventTypeKey] || greenDrivingIconUrls[1]
                      const markerIcon = L.divIcon({
                        className: 'green-driving-marker',
                        html: `<img src="${iconUrl}" alt="" style="width:24px;height:24px;" />`,
                        iconSize: [24, 24],
                        iconAnchor: [12, 12]
                      })
                      return (
                        <Marker key={item.key} position={item.position} icon={markerIcon}>
                          <LeafletTooltip permanent={false} direction="top">
                            <span>{eventLabels[item.eventTypeKey]}: {item.timestamp != null ? moment(item.timestamp).format('DD/MM/YYYY HH:mm:ss') : '-'}</span>
                          </LeafletTooltip>
                        </Marker>
                      )
                    })}
                  </Map>
                </div>
              ) : (
                <>
                  {[1, 2, 3].map((k) => (
                    <div key={k} style={{ marginBottom: 24 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                        <img alt="" src={require(`assets/images/icon/${eventIcons[k]}.png`)} style={{ width: 24, height: 24 }} />
                        <span style={{ fontWeight: 600 }}>{eventLabels[k]} ({(logs[k] && logs[k].length) || 0})</span>
                      </div>
                      <Table
                        size="small"
                        columns={tableColumns}
                        dataSource={(logs[k] || []).map((row, i) => ({ ...row, key: `${k}-${i}` }))}
                        pagination={false}
                        style={{ marginTop: 4 }}
                      />
                    </div>
                  ))}
                </>
              )}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
                <Button
                  type="primary"
                  size="small"
                  onClick={() => setGreenDrivingMapView(!greenDrivingMapView)}
                >
                  Switch to {greenDrivingMapView ? 'Table' : 'Map'} View
                </Button>
                <span style={{ fontWeight: 'bold' }}>Total: {totalEvents} event(s)</span>
              </div>
            </Modal>
          )
        }
        const logsSingle = (logs[greenDrivingLogModalType]) || []
        return (
          <Modal
            title={`${eventLabels[greenDrivingLogModalType]} Events`}
            visible={true}
            onCancel={() => setGreenDrivingLogModalType(null)}
            footer={null}
            zIndex={DEVICE_DETAILS_MODAL_Z_INDEX}
            width="90%"
            wrapClassName="device-details-modal"
            style={{ top: 10 }}
          >
            <GreenDrivingEventsModal
              events={logsSingle}
              eventTypeLabel={eventLabels[greenDrivingLogModalType]}
              eventTypeKey={greenDrivingLogModalType}
            />
          </Modal>
        )
      })()}

      {overspeedModalOpen && (() => {
        const overspeed = rangeData && rangeData.processedData && rangeData.processedData.overspeed_summary
        if (!overspeed) return null
        const events = overspeed.overspeed_events || []
        const eventsWithPosition = events.map((evt, i) => {
          const position = parseLatLong(evt.start_location)
          return position ? { ...evt, key: `os-${i}`, position } : null
        }).filter(Boolean)
        const mapCenter = eventsWithPosition.length > 0 ? eventsWithPosition[0].position : [20.5937, 78.9629]
        const assetLabel = assetData
          ? `${assetData.assetCode || '-'} / ${assetData.altName || '-'} / ${assetData.ownerCode || '-'}`
          : 'Asset'
        const columns = [
          { title: 'Speed Limit (Km/h)', key: 'speedLimit', render: () => (overspeed.speed_limit != null && overspeed.speed_limit !== '') ? Number(overspeed.speed_limit) : '-' },
          { title: 'Duration (s)', dataIndex: 'duration', key: 'dur', render: (v) => v != null ? (Number(v) / 1000).toFixed(2) : '-' },
          { title: 'Avg Speed', dataIndex: 'average_speed', key: 'avg', render: (v) => v != null ? Number(v).toFixed(2) : '-' },
          { title: 'Max Speed', dataIndex: 'max_speed', key: 'max', render: (v) => v != null ? Number(v).toFixed(2) : '-' },
          { title: 'Start', dataIndex: 'start_timestamp', key: 'start', render: (v) => v != null ? moment(v).format('DD/MM/YYYY HH:mm:ss') : '-' },
          { title: 'End', dataIndex: 'end_timestamp', key: 'end', render: (v) => v != null ? moment(v).format('DD/MM/YYYY HH:mm:ss') : '-' },
          { title: 'Start Location', dataIndex: 'start_location', key: 'startLoc', render: (v) => v || '-' },
          { title: 'End Location', dataIndex: 'end_location', key: 'endLoc', render: (v) => v || '-' }
        ]
        const overspeedMarkerIcon = L.divIcon({
          className: 'overspeed-marker',
          html: `<span style="font-size:20px;">🚗</span>`,
          iconSize: [24, 24],
          iconAnchor: [12, 12]
        })
        return (
          <Modal
            title="Overspeed Events"
            visible={true}
            onCancel={() => { setOverspeedModalOpen(false); setOverspeedMapView(false) }}
            footer={null}
            zIndex={DEVICE_DETAILS_MODAL_Z_INDEX}
            width={900}
            wrapClassName="device-details-modal"
          >
            <div style={{ marginBottom: 16 }}>
              <span style={{ fontWeight: 600 }}>{assetLabel}</span>
              {overspeed.speed_limit != null && overspeed.speed_limit !== '' && (
                <span style={{ marginLeft: 12 }}>Speed limit: {Number(overspeed.speed_limit)}</span>
              )}
            </div>
            {overspeedMapView ? (
              <div style={{ height: '500px' }}>
                {eventsWithPosition.length > 0 ? (
                  <Map
                    center={mapCenter}
                    zoom={eventsWithPosition.length > 0 ? 12 : 10}
                    maxZoom={tileLayerConfig.maxZoom || 18}
                    attributionControl={false}
                    style={{ height: '100%' }}
                  >
                    <TileLayer
                      url={tileLayerConfig.url}
                      subdomains={tileLayerConfig.subdomains}
                    />
                    <GeoJSON data={geojsonIndia} style={{ color: isDarkMode ? '#64748b' : 'grey', weight: 1 }} />
                    <GeoJSONLabels zoom={18} minZoomLevel={17} />
                    {eventsWithPosition.map((item) => (
                      <Marker key={item.key} position={item.position} icon={overspeedMarkerIcon}>
                        <LeafletTooltip permanent={false} direction="top">
                          <span>
                            {item.start_timestamp != null ? moment(item.start_timestamp).format('DD/MM/YYYY HH:mm') : '-'} · Avg: {item.average_speed != null ? Number(item.average_speed).toFixed(0) : '-'} km/h
                          </span>
                        </LeafletTooltip>
                      </Marker>
                    ))}
                  </Map>
                ) : (
                  <div style={{ padding: 24, textAlign: 'center', color: isDarkMode ? '#c9d5e1' : '#666' }}>No location data available for these events.</div>
                )}
              </div>
            ) : (
              <Table
                size="small"
                columns={columns}
                dataSource={events.map((row, i) => ({ ...row, key: i }))}
                pagination={{ pageSize: 10 }}
              />
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
              <Button
                type="primary"
                size="small"
                onClick={() => setOverspeedMapView(!overspeedMapView)}
              >
                Switch to {overspeedMapView ? 'Table' : 'Map'} View
              </Button>
              <span style={{ fontWeight: 'bold' }}>Total: {events.length} event(s)</span>
            </div>
          </Modal>
        )
      })()}
      {bleRecordsModalVisible && towingData && towingData.data && (() => {
        const syntheticRecords = (towingData.syntheticTagData || []).filter(r => r.synthetic)
        const hasSynthetic = syntheticRecords.length > 0
        const bleDisplayData = showBleRecordsSynthetic && hasSynthetic
          ? [...towingData.data, ...syntheticRecords]
              .sort((a, b) => Number(a.timestamp || 0) - Number(b.timestamp || 0))
          : towingData.data
        return (
          <Modal
            title={`BLE Records — ${towingData.data.length} detections`}
            visible={bleRecordsModalVisible}
            onCancel={() => { setBleRecordsModalVisible(false); setShowBleRecordsSynthetic(false) }}
            footer={null}
            width={820}
            zIndex={DEVICE_DETAILS_MODAL_Z_INDEX}
          >
            {hasSynthetic && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10, padding: '6px 10px', background: 'rgba(250,173,20,0.08)', borderRadius: 4, border: '1px solid rgba(250,173,20,0.3)' }}>
                <Switch
                  size="small"
                  checked={showBleRecordsSynthetic}
                  onChange={setShowBleRecordsSynthetic}
                />
                <span style={{ fontSize: 12 }}>Show {syntheticRecords.length} synthetic record(s)</span>
                <span style={{ fontSize: 11, opacity: 0.65 }}>(inserted by towing detection — debug only)</span>
              </div>
            )}
            <Table
              dataSource={bleDisplayData}
              rowKey={(r, i) => i}
              size="small"
              pagination={{ pageSize: 10, size: 'small' }}
              scroll={{ x: true }}
              rowClassName={(r) => r.synthetic ? 'ble-modal-row--synthetic' : ''}
              columns={[
                {
                  title: 'Time',
                  key: 'time',
                  width: 135,
                  render: (_, r) => {
                    const ts = r.timestamp || r.Timestamp
                    return ts ? moment(Number(ts)).format('DD-MM-YY HH:mm:ss') : '-'
                  },
                },
                {
                  title: 'Beacon MAC',
                  key: 'mac',
                  width: 160,
                  render: (_, r) => {
                    const mac = r.instanceId || r.instanceid || r.instancsid || r.mac || '-'
                    const asset = bleAssetsMap && bleAssetsMap[mac]
                    const label = asset
                      ? [asset.assetCode, asset.ownerCode].filter(Boolean).join(' / ') || null
                      : null
                    return (
                      <span>
                        {label && <span style={{ display: 'block', fontWeight: 600 }}>{label}</span>}
                        <span style={{ fontSize: label ? 11 : 13, opacity: label ? 0.55 : 1, fontFamily: 'monospace' }}>{mac}</span>
                      </span>
                    )
                  },
                },
                {
                  title: 'Status',
                  key: 'status',
                  width: 100,
                  render: (_, r) => {
                    const s = (r.status || '').toUpperCase()
                    const colors = { FOUND: '#52c41a', LOST: '#f5222d', ACTIVE: '#1890ff', TOWING: '#fa8c16' }
                    return (
                      <span>
                        {s ? <span style={{ color: colors[s] || undefined, fontWeight: 500 }}>{s}</span> : '-'}
                        {r.synthetic && (
                          <span style={{ marginLeft: 5, fontSize: 10, background: '#fa8c16', color: '#fff', borderRadius: 3, padding: '0 4px', verticalAlign: 'middle' }}>SYNTH</span>
                        )}
                      </span>
                    )
                  },
                },
                {
                  title: 'Lat / Lng',
                  key: 'lat_long',
                  width: 155,
                  render: (_, r) => {
                    const ll = r.lat_long
                    if (!ll || typeof ll !== 'string') return '-'
                    const parts = ll.split(',').map(s => parseFloat(s.trim()))
                    if (parts.length < 2 || isNaN(parts[0]) || isNaN(parts[1])) return ll
                    if (parts[0] === 0 && parts[1] === 0) return '-'
                    return (
                      <span style={{ fontSize: 11, fontFamily: 'monospace' }}>
                        {parts[0].toFixed(5)}, {parts[1].toFixed(5)}
                      </span>
                    )
                  },
                },
                {
                  title: 'RSSI',
                  key: 'rssi',
                  width: 90,
                  render: (_, r) => {
                    const rssi = r.rssi || r.RSSI || r.rssiValue
                    if (!rssi) return '-'
                    const d = Math.pow(10, (-60 - Number(rssi)) / 40)
                    const dist = d < 1 ? '<1m' : d >= 1000 ? `${(d / 1000).toFixed(1)}km` : `${Math.round(d)}m`
                    return `${rssi} (~${dist})`
                  },
                },
                {
                  title: 'Battery',
                  key: 'battery',
                  width: 75,
                  render: (_, r) => {
                    const mv = r.batteryMv || r.battery_mv || r.batterymv
                    return mv != null ? `${mv} mV` : '-'
                  },
                },
              ]}
            />
          </Modal>
        )
      })()}
    </>
  );
}

export default DeviceInfoData;
